import React from 'react';
import gpt3Logo from '../../logo.svg';
import './Footer.css';

const Footer = () => (
  <div className="gpt3__footer section__padding">
    <div className="gpt3__footer-heading">
      <h1 className="gradient__text">Do you want to step in to the future before others</h1>
    </div>

    <div className="gpt3__footer-btn">
      <p>Request Early Access</p>
    </div>

    <div className="gpt3__footer-links">
      <div className="gpt3__footer-links_logo">
        <img src={gpt3Logo} alt="gpt3_logo" />
        <p>React Single Page App <br /> All Rights Reserved</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Links</h4>
        <p><a href="https://github.com/Uzair-Asim">GitHub</a></p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Company</h4>
        <p>Terms & Conditions(Not active)</p>
        <p>Privacy Policy(Not active)</p>
        <p>Contact(Not active)</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Get in touch</h4>
        <p><a href="mailto:uzairasim2001@gmail.com?I'd like to...">Email</a></p>
        <p><a href="https://www.linkedin.com/in/uzair-asim-8a2833235/">LinkedIn</a></p>
        <p>1234-5678912</p>
      </div>
    </div>

    <div className="gpt3__footer-copyright">
      <p>@2023 GPT-4. All rights reserved.</p>
    </div>
  </div>
);

export default Footer;